import { cloneElement, ReactElement } from 'react';
import { Tooltip } from '@mui/material';
import useHasAccess from '../../hooks/useHasAccess';

interface PermissionGateProps {
  sectionKey: string;
  children: ReactElement;
  tooltipMessage?: string;
}

const PermissionGate = ({
  sectionKey,
  children,
  tooltipMessage = 'You need permission to access this section. Contact your organization owner.',
}: PermissionGateProps) => {
  const hasAccess = useHasAccess(sectionKey);

  if (hasAccess) return children;

  return (
    <Tooltip title={tooltipMessage} arrow>
      <span style={{ display: 'inline-block' }}>
        {cloneElement(children, {
          disabled: true,
          onClick: undefined,
          style: {
            ...(children.props.style || {}),
            pointerEvents: 'none',
            opacity: 0.5,
          },
        })}
      </span>
    </Tooltip>
  );
};

export default PermissionGate;
